import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "/api";

// Plain axios, not services/api: the site's forms are public, and the backend answers 401 to a
// request that carries an expired login token, even on a public endpoint.
export const submitInquiry = (payload) => axios.post(`${API_URL}/public/contact`, payload);
